import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

/**
 * Hook para listar empresas do usuário logado a partir do token externo
 * @param {string} userId - ID do usuário logado
 * @returns {Object} - { companies, loading, error }
 */
export const useCompanies = (userId) => {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Buscar dados do usuário do Redux
  const user = useSelector(state => state.app?.user);

  useEffect(() => {
    const loadCompanies = () => {
      if (!userId) return;

      setLoading(true);
      setError(null);

      try {
        // Buscar empresas do token externo no Redux
        const externalEmpresas = user?.external_data?.empresas;

        if (externalEmpresas && Array.isArray(externalEmpresas)) {
          // Formatar empresas para o formato esperado pelo componente
          const formattedCompanies = externalEmpresas.map(empresa => ({
            value: empresa.id,
            label: empresa.nome,
            id: empresa.id,
            name: empresa.nome
          }));

          setCompanies(formattedCompanies);
        } else {
          // Se não há empresas no token externo, retornar array vazio
          setCompanies([]);
        }
      } catch (err) {
        setError("Erro ao carregar empresas do token externo");
        console.error("Erro ao carregar empresas:", err);
        setCompanies([]);
      } finally {
        setLoading(false);
      }
    };

    loadCompanies();
  }, [userId, JSON.stringify(user?.external_data?.empresas)]);

  return { companies, loading, error };
};

export default useCompanies;